/**
 * Requirement from IPEXREQ-1386
 * @param language The language code (e.g., 'en', 'zh').
 * @param country The country code (e.g., 'CN', 'SG', 'SA').
 * @returns The overridden font language code based on the language and country.
 */
export const fontLanguageOverride = (_country: string, _language: string) => {
  const country = _country.toUpperCase()
  const language = _language.toLowerCase()

  // Handle Chinese variants
  if (language === 'zh') {
    return country === 'CN' || country === 'SG' ? 'zh-Hans' : 'zh-Hant'
  }
  // Handle Saudi Arabia language variant
  if (country === 'SA') {
    return language + '-SA'
  }

  return language
}
